import { connect } from 'react-redux';
import TableControlPerpus from '../../../views/Library/TableControlPerpus/TableControlPerpus.library.view';
import { getStudent } from '../../../states/thunks/student.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}

export default connect(null, mapDispatchToProps)(TableControlPerpus);
